<div class="unauthorised" *ngIf="loaded">
  <div class="unauthorised-outer">
    <div class="unauthorised-middle">
      <div class="unauthorised-inner">
        <p class="unauthorised-inner-text">
          ⛔ Vous n'êtes pas autorisé à accéder à cette application
        </p>
        <div class="unauthorised-inner-login">
          <lib-andromeda-button (click)="redirectToHome()"
            >Se connecter</lib-andromeda-button
          >
        </div>
      </div>
    </div>
  </div>
</div>
